module.exports = __webpack_public_path__ + "static/img/preview_t1.7254db4.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/preview_t1.png
// module id = ZtBi
// module chunks = 1